var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ImmersivePage",
    {
      attrs: {
        route: _vm.homePageLink,
        appBarTitle: _vm.reportVisible ? _vm.exam.title : "",
      },
    },
    [
      _vm.reportVisible
        ? _c(
            "KPageContainer",
            { staticClass: "container", attrs: { topMargin: 50 } },
            [
              _vm.loading
                ? _c("KCircularLoader")
                : _vm.exerciseContentNodes && _vm.exerciseContentNodes.length
                ? _c(
                    "div",
                    [
                      _c("ExamReport", {
                        attrs: {
                          contentId: _vm.exam.id,
                          title: _vm.exam.title,
                          userName: _vm.userName,
                          userId: _vm.userId,
                          selectedInteractionIndex:
                            _vm.selectedInteractionIndex,
                          questionNumber: _vm.questionNumber,
                          tryIndex: _vm.tryIndex,
                          exercise: _vm.exercise,
                          exerciseContentNodes: _vm.exerciseContentNodes,
                          navigateTo: _vm.navigateTo,
                          questions: _vm.questions,
                          sections: _vm.exam.question_sources,
                        },
                        on: { noCompleteTries: _vm.noCompleteTries },
                      }),
                    ],
                    1
                  )
                : _c("div", [
                    _c("p", { staticClass: "no-exercise" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$tr("missingContent")) +
                          "\n      "
                      ),
                    ]),
                  ]),
            ],
            1
          )
        : _vm.showQuizReportComingSoonModal
        ? _c(
            "div",
            [
              _c(
                "KModal",
                {
                  attrs: {
                    title: _vm.$tr("quizReportComingSoon"),
                    submitText: _vm.coreString("closeAction"),
                  },
                  on: {
                    submit: function ($event) {
                      return _vm.openHomePage()
                    },
                  },
                },
                [
                  _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$tr("quizReportComingSoonDetails")) +
                        "\n      "
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }